import React from 'react';
import "./Carousel.css";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from 'react';

const Carousel = (props: any) => {
  const [index, setIndex] = useState(0);
  // const [active, setActive] = useState(0);
  const [currentWidth, setCurrentWidth] = useState(0);
  const slideEl = useRef(document.createElement("div"));
  const width = props.width;
  const items = props.items;
  const size = props.size;
  const timer = useRef<number>();
  

const scheduleNext = () => {
  timer.current = window.setTimeout(() => {
    if(index + items >= size) {
      handleClick(0);  
    } else {
      handleClick(index + items);  
    }
    clearTimeout(timer.current);
  }, 6000);
}

  useEffect(() => {
    scheduleNext();
  }, [index])
  
  const slideLeft = () => {
    handleClick(index - items);
    // setIndex(index - items);
    // if (slideEl) {
    //   const x = width + currentWidth;
    //   setCurrentWidth(x);
    //   slideEl.current.style.transform = `translateX(${x}px)`;
    // }
  };

  const slideRight = () => {
    handleClick(index + items);
    // setIndex(index + items);
    // if (slideEl) {
    //   const x = currentWidth - width;
    //   setCurrentWidth(x);
    //   slideEl.current.style.transform = `translateX(${x}px)`;
    // }
  };

  const clickDot = (x: number) => {
    const pixel = (x / items) * width;
    if(slideEl.current) {
      slideEl.current.style.transform = `translateX(${-pixel}px)`;
    }
  };

  const handleClick = (i: number) => {
    clearTimeout(timer.current);
    setIndex(i);
    clickDot(i);
  };
  
  const isActive = (current: number): string => {
    if (index === current) {
      return "active";
    }
    return "inactive";
  };
  const generateDots = () => {
    let arrayOfDots = [];
    for (let i = 0; i < size; i = i + items) {
      let dot = (
        <div className={isActive(i)} onClick={() => handleClick(i)}></div>
      );
      arrayOfDots.push(dot);
    }
    return arrayOfDots;
  };

  return (
    <div className="carousel">
      <div className="navButton">
        {props.showArrow && (
          <>
            {
              <div 
              className={`mover ${index + items >= size ? "disabled" : ""}`}
                onClick={slideRight}
              >
                <i style={{ fontSize: 22}} className="fa fa-angle-right" aria-hidden="true"></i>
              </div>
            }
            {
              <div
              className={`mover ${index === 0 ? "disabled" : ""}`}
                onClick={slideLeft}
              >
                <i style={{ fontSize: 22}} className="fa fa-angle-left" aria-hidden="true"></i>
              </div>
            }
          </>
        )}
      </div>
      <div className="slider" style={{ width: width }}>
        <div className="slide" ref={slideEl}>
          {props.children}
        </div>
      </div>
      {props.showDot && <div className="carousel-dot">{generateDots()}</div>}
    </div>
  );
};

export default Carousel;
